import * as React from "react";

function SvgElipses(props) {
  return (
    <span className="iiht-elipse">
      <svg xmlns="http://www.w3.org/2000/svg" width={5} height={19} {...props}>
        <g data-name="Group 11076" transform="translate(-715 -442)" fill="#3c4252">
          <circle data-name="Ellipse 691" cx={2.5} cy={2.5} r={2.5} transform="translate(715 442)" />
          <circle data-name="Ellipse 692" cx={2.5} cy={2.5} r={2.5} transform="translate(715 449)" />
          <circle data-name="Ellipse 693" cx={2.5} cy={2.5} r={2.5} transform="translate(715 456)" />
        </g>
      </svg>
    </span>
  );
}

export default SvgElipses;
